import {Component, Watch} from "vue-property-decorator";
import {nowPath} from "../modules/utils";
import UserRequired from "./UserRequired";
import {Company, companyroleid} from "../modules/models";
import rd from "@/modules/vRoutedefs";
import {ignoreRedundantNavErr} from "@/router";

@Component
export default class CompanyUserRequired extends UserRequired {
    get company(): Company {
        let c = this.baseApi.company;
        if (c == null) {
            c = new Company("FEIL: FIRMA MANGLER", 0);
        }
        return c;
    }

    @Watch("company", {immediate: true})
    onCompanyChange(c: Company | null) {
        if (c == null || c.orgNum === 0) {
            if(this.baseApi.authenticated) { // Only go to company select if user is logged in
                ignoreRedundantNavErr(this.$router.push({name: rd.company.name, query: rd.company.q(null, nowPath())}));
            } else {
                throw new Error("Side krever at firma er valgt.");
            }
        }
    }

    private pSomeCompanyRoleRequired: companyroleid[] | null = null;

    requireCompanyRoles(roleIds: companyroleid[] | null) {
        // always add super to roleIds, if it is not null
        this.pSomeCompanyRoleRequired = roleIds;
    }

    get rolesRequired() {
        return this.pSomeCompanyRoleRequired;
    }

    get roleRequiredOk() {
        if(this.pSomeCompanyRoleRequired) {
            return this.user.hasAnyCompanyRoleType(this.pSomeCompanyRoleRequired, this.company.orgNum);
        }
        return true;
    }

    @Watch("roleRequiredOk")
    onRoleRequiredOkChanged() {
        if(!this.roleRequiredOk) {
            // Redirect to unauthorized page
            const currentPath = this.$route.path;
            this.emitSnack(`Du har ikke tilgang til ${currentPath}.`, "error");
            ignoreRedundantNavErr(this.$router.replace({name: rd.unauthorized.name}));
        }
    }
}